// extracted by mini-css-extract-plugin
module.exports = {"CommonProducts":"common-products_CommonProducts__Az36c"};